<template>
  <v-container fluid class="white py-8 py-md-16">
    <v-container>
      <v-row class="mb-10">
        <v-col cols="12" class="text-center">
          <span
            class="overline secondary--text font-weight-bold"
            data-aos="fade-down"
          >
            CÓMO EMPEZAMOS
          </span>
          <h2
            class="display-1 greydark--text font-weight-bold mt-2"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            Tres pasos para transformar tu operación
          </h2>
          <p
            class="text-h6 greylight--text mt-4 mx-auto"
            style="max-width: 700px;"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Sin largos proyectos de implementación.
            Resultados desde la primera semana.
          </p>
        </v-col>
      </v-row>

      <v-row class="align-stretch">
        <v-col
          v-for="(step, index) in steps"
          :key="step.title"
          cols="12"
          md="4"
          data-aos="fade-up"
          :data-aos-delay="300 + (index * 100)"
        >
          <v-card class="pa-6 text-center h-100" elevation="3">
            <div class="step-number mb-4">
              <v-avatar :color="step.color" size="80">
                <span class="white--text text-h4 font-weight-bold">
                  {{ index + 1 }}
                </span>
              </v-avatar>
            </div>
            <h3 class="text-h5 greydark--text mb-3 font-weight-bold">
              {{ step.title }}
            </h3>
            <p class="text-body-1 greylight--text mb-3">
              {{ step.duration }}
            </p>
            <v-list class="transparent">
              <v-list-item
                v-for="(item, idx) in step.items"
                :key="idx"
                class="px-0"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon :color="step.color" small>mdi-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="greydark--text text-body-2">
                    {{ item }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-col
          cols="12"
          class="text-center"
          data-aos="fade-up"
          data-aos-delay="600"
        >
          <v-btn
            :x-large="$vuetify.breakpoint.mdAndUp"
            :large="$vuetify.breakpoint.smAndDown"
            color="secondary"
            class="white--text"
            href="#contact"
            rounded
            depressed
          >
            Hablemos de tu industria
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'HubHowItWorks',
  data() {
    return {
      steps: [
        {
          title: 'Diagnóstico Express',
          duration: '15 minutos',
          color: 'accent',
          items: [
            'Analizamos tu proceso más crítico',
            'Identificamos puntos de fuga específicos de tu industria',
            'Sin compromiso',
          ],
        },
        {
          title: 'Demo Personalizada',
          duration: '30 minutos',
          color: 'secondary',
          items: [
            'Te mostramos la vertical configurada para tu caso',
            'Flujo real con tus documentos y datos',
            'Definimos el alcance inicial',
          ],
        },
        {
          title: 'Implementación Rápida',
          duration: '1 semana',
          color: 'success',
          items: [
            'Primer proceso en producción',
            'Capacitación de tu equipo',
            'Resultados medibles desde el día 1',
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.v-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
}
</style>
